export default __webpack_public_path__ + "static/media/shopify.491059be.png";